import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

const TerminalDetails = ({ selectedCard }) => {
  const { t } = useTranslation();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const handleImageClick = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-left" />
      </button>
    );
  }
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

    const lightboxSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: lightboxIndex,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };


  if (!selectedCard) return null;

  const baseKey = `terminal_catalog.terminal_cards.terminal_${selectedCard.id}`;
  const name = t(`${baseKey}.name`, selectedCard.name);
  const priceShort = t(`${baseKey}.price_short`, selectedCard.price);
  const short = t(`${baseKey}.short`, selectedCard.short_desctiption);

  const translatedParams = t(`${baseKey}.parameters`, {
    returnObjects: true,
    defaultValue: selectedCard.parameters || [],
  });

  const paramsArray = Array.isArray(translatedParams)
    ? translatedParams
    : selectedCard.parameters || [];

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <div className="terminal-modal">
        {/* IMAGES */}
        {selectedCard.images.length > 3 ? (
          <Slider {...settings}>
            {selectedCard.images.map((item, index) => (
              <div key={index}>
                <img
                  src={item}
                  alt="terminal image"
                  onClick={() => handleImageClick(index)}                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className="terminal-modal__slide">
            {selectedCard.images.map((item, index) => (
              <div key={index}>
                <img
                  className="terminal-modal__slideImg"
                  src={item}
                  alt="terminal image"
                  onClick={() => handleImageClick(index)}                />
              </div>
            ))}
          </div>
        )}

        {/* TEXT CONTENT */}
        <div className="terminal-modal__card">
          <h3 className="terminal-modal__name">{name}</h3>

          {/* price */}
          {/* <p className="terminal-modal__price">
            <strong>{priceShort}</strong>
          </p> */}

          {/* parameters list */}
          <ul className="terminal-modal__list">
            {paramsArray.map((param, index) => (
              <li key={index} className="terminal-modal__item">
                {param}
              </li>
            ))}
          </ul>
        </div>
      </div>
        {/* LIGHTBOX OVERLAY WITH SLIDER */}
      {lightboxOpen && (
        <div className="terminal-lightbox" onClick={closeLightbox}>
          <div
            className="terminal-lightbox__content"
            onClick={(e) => e.stopPropagation()} // prevent close on slider click
          >
            <button
              className="terminal-lightbox__close"
              type="button"
              onClick={closeLightbox}
            >
              ✕
            </button>

            <Slider {...lightboxSettings}>
              {selectedCard.images.map((item, index) => (
                <div key={index} className="terminal-lightbox__slide">
                  <img
                    src={item}
                    alt="terminal big"
                    className="terminal-lightbox__img"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
};

export default TerminalDetails;
